module.exports = __webpack_public_path__ + "assets/img/tec.65ad8beb.png";